'use client';
import { currentAccountIdAtom, currentAccountUsersAtom } from '@/app/states/atoms';
import { MenuItem } from '@headlessui/react';
import { useAtom } from 'jotai';

export const AccountSwitcher = () => {
  const [currentAccountId, setCurrentAccountId] = useAtom(currentAccountIdAtom);
  const [currentAccountUsers] = useAtom(currentAccountUsersAtom);
  function switchAccount(accountId: string) {
    setCurrentAccountId(accountId);
    window.location.href = '/';
  }
  return currentAccountUsers.map(
    accountUser =>
      accountUser.accountId !== currentAccountId && (
        <div className="py-1" key={accountUser.accountId}>
          <MenuItem>
            <div
              onClick={() => switchAccount(accountUser.accountId)}
              className="px-4 py-3 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
            >
              <p className="text-xs text-gray-400">Switch to</p>
              <p className="truncate font-medium text-gray-700">
                {accountUser.account.name} Account
              </p>
            </div>
          </MenuItem>
        </div>
      ),
  );
};
